<template>
    <div>
        <loading v-show="isLoading"></loading>
        <el-row :gutter="20">
            <el-col :span="24" >
                <el-card class="box-card" :style="'height:'+bodyHeight+'px'">
                    <div slot="header" class="clearfix">
                        <el-button type="success" @click="getExl" icon="el-icon-download" size="small" plain>导出结果</el-button>
                         <el-input
                            size="small"
                            style="width:200px;margin-left:30px;"
                            placeholder="请输入用户手机号"
                            prefix-icon="el-icon-search"
                            @keydown.enter.native="query"
                            v-model="queryModel.queryTxt">
                        </el-input>
                        <el-select size="small" style="margin-left:30px;width:100px"   v-model="queryModel.type" clearable placeholder="交易类型">
                            <el-option label="充值" :value="1"> </el-option>
                            <el-option label="提现" :value="2"> </el-option>
                            <el-option label="任务扣款" :value="3"> </el-option>
                            <el-option label="好评扣款" :value="4"> </el-option>
                            <el-option label="任务退款" :value="5"> </el-option>
                            <el-option label="任务补扣" :value="6"> </el-option>
                            <el-option label="订单撤销" :value="7"> </el-option>
                            <el-option label="后台充值" :value="8"> </el-option>
                            <el-option label="后台扣款" :value="9"> </el-option>
                            <el-option label="推广收入" :value="10"> </el-option>
                        </el-select>
                        <el-date-picker
                        value-format="yyyy-MM-dd HH:mm:ss"
                        size="small" style="width:300px;margin-left:30px"
                        v-model="queryModel.createTimes"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                        </el-date-picker>
                        <el-tooltip class="item" effect="dark" content="查询" placement="top">
                            <el-button type="primary" size="small" style="margin-left:30px;" @click="query" icon="el-icon-search" plain circle></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="重置" placement="top">
                            <el-button type="primary" size="small" style="margin-left:15px;" @click="reset" icon="el-icon-aim" plain circle></el-button>
                        </el-tooltip>
                        <template>
                            <b style="font-size:13px;margin-left:20px">总计：</b>
                            <el-tag class="tag_btn" size="mini"  type="danger" effect="dark">￥{{moneyTotal.toFixed(2)}}</el-tag>
                        </template>
                        <el-pagination
                        style="float:right"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryModel.pIndex"
                        :page-sizes="[20, 40, 60, 80]"
                        :page-size="queryModel.pSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                        </el-pagination>
                    </div>
                    <el-table
                    :height="bodyHeight-130"
                    v-loading="isLoading"
                    :data="tableData"
                    style="width: 100%">
                        <el-table-column
                            prop="MemberId"
                            label="用户Id">
                        </el-table-column>
                       <el-table-column
                            prop="Phone"
                            label="手机号">
                        </el-table-column>
                        <el-table-column
                            label="任务编号">
                            <template slot-scope="scope">
                                    <el-link v-if="scope.row.TaskCode==''" icon="el-icon-s-flag" type="info">无</el-link>
                                    <el-link v-else icon="el-icon-s-flag" type="primary">{{scope.row.TaskCode}}</el-link>
                            </template>
                        </el-table-column>
                         <el-table-column
                            label="店铺名称">
                            <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" :content="scope.row.ShopName" placement="bottom">
                                <span v-if="scope.row.ShopType==1" >
                                    <div style="margin-left:5px;width:120px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                        <img  style="margin-bottom:-5px;height:20px;background-color:#ff6a3c;border-radius:5px"  src="../assets/taobao.png">
                                        {{scope.row.ShopName}}
                                        </div>
                                </span>
                                <span v-else-if="scope.row.ShopType==2" >
                                    <div style="margin-left:5px;width:120px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                        <img  style="margin-bottom:-5px;height:20px;background-color:#9765ff;border-radius:5px" src="../assets/jindong.png">
                                        {{scope.row.ShopName}}
                                    </div>
                                </span>
                                <span v-else-if="scope.row.ShopType==6" >
                                    <div style="margin-left:5px;width:120px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                        <img  style="margin-bottom:-5px;height:20px;background-color:#9765ff;border-radius:5px" src="../assets/dy.jpg">
                                        {{scope.row.ShopName}}
                                    </div>
                                </span>
                                <span  v-else-if="scope.row.ShopType==3">
                                    <div style="margin-left:5px;width:120px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                        <img  style="margin-bottom:-5px;height:20px;background-color:#fc5487;border-radius:5px"  src="../assets/pinduoduo.png">
                                        {{scope.row.ShopName}}
                                    </div>
                                </span>
                                  <span  v-else>
                                      
                                  </span>
                            </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="类型">
                            <template slot-scope="scope">
                                <el-tag size="mini"   type="danger" v-if="scope.row.Type==1">充值</el-tag>
                                <el-tag size="mini"   type="danger" v-else-if="scope.row.Type==2">提现</el-tag>
                                <el-tag size="mini"  type="danger" v-else-if="scope.row.Type==3">任务扣款</el-tag>
                                <el-tag size="mini"  type="danger" v-else-if="scope.row.Type==4">好评扣款</el-tag>
                                <el-tag size="mini"  type="danger" v-else-if="scope.row.Type==5">任务退款</el-tag>
                                <el-tag size="mini" type="danger" v-else-if="scope.row.Type==6">任务补扣</el-tag>
                                <el-tag size="mini"  type="danger" v-else-if="scope.row.Type==7">订单撤销</el-tag>
                                <el-tag size="mini"  type="danger" v-else-if="scope.row.Type==8">后台充值</el-tag>
                                <el-tag size="mini"  type="danger" v-else-if="scope.row.Type==9">后台扣款</el-tag>
                                <el-tag size="mini"  type="danger" v-else-if="scope.row.Type==10">推广收入</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="账户">
                            <template slot-scope="scope">
                                <el-tag size="mini" effect="dark" type="primary" >{{scope.row.AccountName}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="Description"
                            label="摘要">
                        </el-table-column>
                        <el-table-column
                            label="金额">
                            <template slot-scope="scope">
                                    <el-link :type="scope.row.Money>0?'danger':'success'">￥{{scope.row.Money.toFixed(2)}}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                        width="140"
                        label="交易后余额">
                            <template slot-scope="scope">
                                <el-link type="warning">￥{{scope.row.Balance.toFixed(2)}}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="CreateTime"
                            label="交易时间">
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import { recordGet,uri } from '@/request.js'

export default {
    data(){
        return {
            url:"",
            total:0,
            bodyHeight:0,
            isLoading:false,
            queryModel:{
                queryTxt:"",
                pSize:20,
                pIndex:1,
                type:"",
                createTimes:[],
                isPraise:false,
            },
            tableData:[],
            moneyTotal:0,
        }
    },
    created(){
        this.bodyHeight=document.documentElement.clientHeight-129;
        this.query();
    },
    mounted(){
       
    },
    methods: {
        getExl(){
           window.open(uri+"/Transaction/GetRecordExl?queryTxt="+this.queryModel.queryTxt+"&type="+(this.queryModel.type==""?0:parseInt(this.queryModel.type))+"&createTimes="+(this.queryModel.createTimes==null?"[]":JSON.stringify(this.queryModel.createTimes))
           );
       },
        query(){
            this.isLoading=true;
            recordGet({
                pIndex:this.queryModel.pIndex,
                pSize:this.queryModel.pSize,
                queryTxt:this.queryModel.queryTxt,
                type:this.queryModel.type==""?0:parseInt(this.queryModel.type),
                createTimes:JSON.stringify(this.queryModel.createTimes),
                isPraise:this.queryModel.isPraise
            },(res)=>{
                this.tableData=res.Result.List;
                this.moneyTotal=res.Result.Total;
                this.total=res.TotalCount;
                setTimeout(() => {
                    this.isLoading=false;
                }, 300);
            })
        },
        reset(){
            this.queryModel={
                queryTxt:"",
                pSize:this.queryModel.pSize,
                pIndex:this.queryModel.pIndex,
                type:"",
                createTimes:[]
            }
        },
        handleSizeChange(val){
            this.queryModel.pSize=val;
            this.query();
        },
        handleCurrentChange(val){
            this.queryModel.pIndex=val;
            this.query();
        }
    }
}
</script>
<style >
.el-dialog__body{
    padding:10px 20px;
}
</style>